var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(!_vm.loading)?_c('div',[_c('SlideFadeTransition',[_c('router-view')],1)],1):_c('div',[_c('FullLoader')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }